// Generated by purs version 0.15.15
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_HttpStatusCode from "../Ouroboros.Models.Brands.HttpStatusCode/index.js";
import * as Ouroboros_Models_Clients_AdminPlan from "../Ouroboros.Models.Clients.AdminPlan/index.js";
import * as Ouroboros_Services_FFI_Env from "../Ouroboros.Services.FFI.Env/index.js";
import * as Ouroboros_Services_FFI_Http from "../Ouroboros.Services.FFI.Http/index.js";
import * as Ouroboros_Services_FFI_TaskEither from "../Ouroboros.Services.FFI.TaskEither/index.js";
import * as Ouroboros_Services_FFI_Uuid from "../Ouroboros.Services.FFI.Uuid/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var validationError = function (message) {
    return {
        type: "BadRequest",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(message),
        statusCode: Data_Maybe.Nothing.value
    };
};
var traceHeaders = function (headers) {
    return Ouroboros_Services_FFI_Http.mkHeaders(append(headers)([ new Data_Tuple.Tuple("X-Trace-ID", Ouroboros_Services_FFI_Uuid.uuidV7(Data_Unit.unit)) ]));
};
var readErrorBody = function (response) {
    return Ouroboros_Services_FFI_TaskEither.tryCatch(function (v) {
        return Ouroboros_Services_FFI_Http.responseText(response);
    })(function (v) {
        return validationError("Response body unavailable");
    });
};
var parseJson = function (response) {
    return Ouroboros_Services_FFI_TaskEither.chain(Ouroboros_Services_FFI_TaskEither.tryCatch(function (v) {
        return Ouroboros_Services_FFI_Http.responseJson(response);
    })(function (v) {
        return validationError("Response validation failed");
    }))(function (payload) {
        var v = Ouroboros_Models_Clients_AdminPlan.decodeAdminPlanResponse(payload);
        if (v instanceof Data_Either.Left) {
            return Ouroboros_Services_FFI_TaskEither.left(validationError("Invalid response payload"));
        };
        if (v instanceof Data_Either.Right) {
            return Ouroboros_Services_FFI_TaskEither.right(v.value0);
        };
        throw new Error("Failed pattern match at Ouroboros.Services.Ouroboros.AdminPlan (line 61, column 7 - line 63, column 42): " + [ v.constructor.name ]);
    });
};
var networkError = /* #__PURE__ */ (function () {
    return {
        type: "NetworkError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Network error"),
        statusCode: Data_Maybe.Nothing.value
    };
})();
var errorFromStatus = function (status) {
    return function (message) {
        var statusCode = new Data_Maybe.Just(Ouroboros_Models_Brands_HttpStatusCode.makeHttpStatusCode(Data_Int.toNumber(status)));
        var cleaned = Data_String_Common.trim(message);
        var fallback = (function () {
            var $14 = cleaned === "";
            if ($14) {
                return "Request failed";
            };
            return cleaned;
        })();
        var $15 = status === 401;
        if ($15) {
            return {
                type: "Unauthorized",
                message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(fallback),
                statusCode: statusCode
            };
        };
        var $16 = status === 403;
        if ($16) {
            return {
                type: "Forbidden",
                message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(fallback),
                statusCode: statusCode
            };
        };
        var $17 = status === 400;
        if ($17) {
            return {
                type: "BadRequest",
                message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(fallback),
                statusCode: statusCode
            };
        };
        var $18 = status === 404;
        if ($18) {
            return {
                type: "NotFound",
                message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(fallback),
                statusCode: statusCode
            };
        };
        return {
            type: "ServerError",
            message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(fallback),
            statusCode: statusCode
        };
    };
};
var requestJson = function (path) {
    return function (init) {
        return Ouroboros_Services_FFI_TaskEither.chain(Ouroboros_Services_FFI_TaskEither.tryCatch(function (v) {
            return Ouroboros_Services_FFI_Http.fetch_(Ouroboros_Services_FFI_Env.apiUrl + path)(init);
        })(function (v) {
            return networkError;
        }))(function (response) {
            var $19 = Ouroboros_Services_FFI_Http.responseOk(response);
            if ($19) {
                return parseJson(response);
            };
            return Ouroboros_Services_FFI_TaskEither.chain(readErrorBody(response))(function (body) {
                return Ouroboros_Services_FFI_TaskEither.left(errorFromStatus(Ouroboros_Services_FFI_Http.responseStatus(response))(body));
            });
        });
    };
};
var createDefaultAdminPlanClient = /* #__PURE__ */ (function () {
    return {
        getPlan: requestJson("/v1/admin/plan")(Ouroboros_Services_FFI_Http.requestInitNoBody("GET")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ])))
    };
})();
export {
    createDefaultAdminPlanClient
};
//# sourceMappingURL=index.js.map
